// ----------------------------------------------------------------------
// <copyright file="Izenda.FormatStyleUtils.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {
  'use strict';
  var CONSTANTS = require('logic/data/Izenda.ReportDesignerFormatsConstants');
  var ITEMS_TYPE = CONSTANTS.ITEMS_TYPE;

  module.exports = {
    /**
     * Get style object for item
     */
    getStyle: function (item) {
      var font = item.font || {};
      var alignment = item.alignment;
      var imageUrl = item.imageUrl;

      var style = {
        fontFamily: font.family,
        fontSize: font.size + 'px',
        fontWeight: font.bold ? 'bold' : 'normal',
        textAlign: alignment || 'none',
        textDecoration: font.underline ? 'underline' : 'none',
        fontStyle: font.italic ? 'italic' : 'normal',
        color: font.color
      };
      
      imageUrl && (style['background-size'] = '100% 100%')
      imageUrl && (style.backgroundImage = 'url(' + imageUrl + ')');
      imageUrl && (style.height = item.height);
      imageUrl && (style.width = item.width); 
      return style;
    },

    /**
     * Get background style
     */
    getBackgroundStyle: function (item) {
      var font = item.font || {};

      return {
        backgroundColor: font.backgroundColor,
      }
    },

    /**
     * Get line style
     */
    getLineStyle: function (item, viewMode) {
      var color = viewMode ? item.color : '#000';
      var dashStyle = viewMode ? item.dashStyle : 'solid';
      var thickness = viewMode ? item.thickness : 4;

      switch (item.type) {
        case ITEMS_TYPE.horizontalRule.value:
        case ITEMS_TYPE.thinHorizontalRule.value:
          return {
            borderTopColor: color,
            borderTopStyle: dashStyle,
            borderTopWidth: thickness
          }
        case ITEMS_TYPE.verticalRule.value:
          return {
            borderLeftColor: color,
            borderLeftStyle: dashStyle,
            borderLeftWidth: thickness
          }
      }
    }
  }
}());



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.FormatStyleUtils.js